<template>
  <AddUser />
</template>
<script>
import appConfig from '@/app.config'
import AddUser from '../../../../components/mooc/tech/users/AddUser.vue'
export default {
  page: {
    title: 'مدیریت کاربران',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'mooc-add-users',
  components: {
    AddUser,
  },
}
</script>
